import '../../style/index.less';
import './index.less';

// style dependencies
import '../../button/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/modal/style/index.js